import { FlightPlanForECargo } from "@/data/payload/api/CargoApiRequest";
import { Pagination } from "./Pagination";
import { OptionsClass } from "./MainApp";
import { AwbTracking, FlightDetail } from "./NGen";
import { flags } from "@/feature-flags";
import { formatDateNormal } from "@/app/infrastructures/misc/Utils";
import moment from "moment";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";

export class CargoEntities {
  pagination: Pagination;
  data: CargoData[];
  constructor(pagination: Pagination, data: CargoData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class DimensionData {
  length = 90;
  width = 60;
  height = 0;
  constructor(fields?: Partial<DimensionData>) {
    Object.assign(this, fields);
  }
}

export class DimensionCustomData {
  pieces = 0;
  length = 30;
  width = 20;
  height = 10;
  grossWeight = 0;
  volumeWeight = 0;
  sttOrBag = "";
  constructor(fields?: Partial<DimensionCustomData>) {
    Object.assign(this, fields);
  }
}

export class DestinationCityData {
  id? = 0;
  code = "";
  name = "";
  label = "";
  constructor(fields?: Partial<DestinationCityData>) {
    Object.assign(this, fields);
  }
}

export class CargoData {
  totalFlight = 0;
  id = 0;
  cargoNumber = "";
  cargoHubName = "";
  bookingRequestId = "";
  isFromRtc = false;
  cargoType = "";
  vehiclePoliceNumber = "";
  originCityCode = "";
  originCityName = "";
  destinationCityCode = "";
  destinationCityName = "";
  airportOriginCityCode = "";
  airportOriginCityName = "";
  airportDestinationCityCode = "";
  airportDestinationCityName = "";
  originDistrictCode = "";
  destinationDistrictCode = "";
  totalStt = 0;
  totalPieces = 0;
  totalGrossWeight = 0;
  totalVolumeWeight = 0;
  sttTotalPiece = 0;
  sttGrossWeight = 0;
  sttVolumeWeight = 0;
  sttProductType = "";
  sttCommodityName = "";
  sttOriginCityId = 0;
  sttDestinationCityId = 0;
  noBag = "";
  createdName = "";
  createdAt = "";
  updatedByName = "";
  totalEstCargoGrossWeight = 0;
  totalEstCargoVolumeWeight = 0;
  totalActualCargoGrossWeight: any = 0;
  totalActualCargoVolumeWeight: any = 0;
  cargoActualPiece = 0;
  partnerName = "";
  partnerType = "";
  cargoCommodity = "";
  cargoCommodityCode = "";
  cargoCommodityName = "";
  cargoProduct = "";
  cargoProductCode = "";
  shcCode = "";
  shcName = "";
  shcDescription = "";
  estimationDepartureData = "";
  estimationDepartureDate = "";
  departureDate = "";
  departureTime = "";
  estimationArrivalDate = "";
  arrivalDate = "";
  arrivalTime = "";
  nGenCreatedAt = "";
  createdBy = "";
  updatedAt = "";
  updatedBy = "";
  detailStt = [] as CargoDetailStt[];
  cargoDimensionCustom = [] as DimensionCustomData[];
  flightsDetail = [] as CargoFlightDetail[];
  totalPiecesBagStt = 0;
  totalPiecesDimension = 0;
  totalGrossDimension = 0;
  actualDimension: DimensionData = new DimensionData();
  estDimension: DimensionData = new DimensionData();
  nog = "";
  partnerId = 0;
  cargoStatus = "";
  flightNumbers = [] as any;
  reasonFailed = "";
  transit = 0;
  isPlaneManual = false;
  isUseSabre = false;
  isOverCutoffTime = false;
  flightPlaneForECargo: Record<string, string | number>[] = [];
  photoProof: string[] = [];
  isAllowUseProof = false;
  isUseNewCalculation = false;
  rcTotalChargeableWeight = 0;
  rcTotalCustomChargeableWeight = 0;
  rcTotalEstimateChargeableWeight = 0;
  totalChargeableWeight = 0;
  cargoTotalChargeableWeight = 0;
  cargoTotalCustomChargeableWeight = 0;
  cargoTotalEstimateChargeableWeight = 0;
  cargoTotalCustomVolumeWeight = 0;
  cargoTotalCustomGrossWeight = 0;
  cargoTotalGrossWeight = 0;
  cargoTotalVolumeWeight = 0;
  cargoTotalEstimateGrossWeight = 0;
  cargoTotalEstimateVolumeWeight = 0;
  calculateType = "";
  isMinimumVolumePerPiece = false;
  minVolumePerPiece = 0;
  isValidAwbManual = false;
  isCargoDimensionOn = false;
  totalDisputeBagging = 0;
  totalBagging = 0;
  isDisputeFromBagging = false;
  isDisputeFromCargo = false;
  isDisputeCargo = false;
  cargoCommodityGroupIsElectronicDg = false;
  cargoCommodityGroupIsDg = false;
  cargoCommodityGroupIsQuarantine = false;
  isNewForm = false;
  driverName = "";
  cargoNog = "";
  onlyTotalStt = 0;
  onlyTotalBag = 0;
  totalBagWithWeightDispute = 0;
  currentChargeableWeight = 0;

  constructor(fields?: Partial<CargoData>) {
    Object.assign(this, fields);
  }

  get isAccountWhitelist() {
    return FlagsPermissionCargo.feature_flight_v2_enable.isEnabled();
  }

  get isUseSabreForRebooking() {
    return this.isAccountWhitelist && this.cargoType === "plane"
      ? false
      : !this.isUseSabre;
  }
}

export class CargoFlightDetail {
  cfNumber = "";
  cfEstDepartureTime = "";
  cfAirportOrigin = "";
  cfAirportDestination = "";

  constructor(fields?: Partial<CargoFlightDetail>) {
    Object.assign(this, fields);
  }
}

export class CargoDetailBagData {
  bagCustomGrossWeight = 0;
  bagGrossWeight = 0;
  bagCustomLength = 0;
  bagCustomWidth = 0;
  bagCustomHeight = 0;
  bagTotalChargeableWeight = 0;
  bagCustomChargeableWeight = 0;
  bagCustomVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  isUseNewCalculation = false;

  constructor(fields?: Partial<CargoDetailBagData>) {
    Object.assign(this, fields);
  }
}

export class CargoDetailSttPiece {
  sttPieceLength = 0;
  sttPieceWidth = 0;
  sttPieceHeight = 0;
  sttPieceGrossWeight = 0;
  sttPieceVolumeWeight = 0;

  constructor(fields?: Partial<CargoDetailSttPiece>) {
    Object.assign(this, fields);
  }
}

export class CargoDetailStt {
  baggingNumber = "";
  baggingVendorNumber = "";
  baggingVendorNo = "";
  sttNumber = "";
  totalPieces = 0;
  grossWeigth = 0;
  volumeWeight = 0;
  productType = "";
  commodity = "";
  action = "";
  origin = "";
  destination = "";
  sttTotalPiece = 0;
  sttGrossWeight = 0;
  sttVolumeWeight = 0;
  sttProductType = "";
  sttCommodityName = "";
  sttOriginCityId = 0;
  sttDestinationCityId = 0;
  destinationCityCode = "";
  destinationCityName = "";
  regionId = "";
  regionName = "";
  commodityGroupCode = "";
  commodityGroupName = "";
  commodityGroupIsDg = false;
  commodityGroup = "";
  shcCode = "";
  shcName = "";
  sttElexysNumber? = "";
  bagCustomGrossWeight? = 0;
  isFromRebooking? = false;
  sttNoRefExternal? = "";
  bagData = new CargoDetailBagData();
  bagGrossWeight = 0;
  bagCustomVolumeWeight = 0;
  bagCustomLength = 0;
  bagCustomWidth = 0;
  bagCustomHeight = 0;
  sttPieces: CargoDetailSttPiece[] = [];
  isScanByBag = false;
  bagCustomChargeableWeight = 0;
  bagTotalChargeableWeight = 0;
  chargeableWeight = 0;
  grossWeight = 0;
  customGrossWeight = 0;
  customChargeableWeight = 0;
  customVolumeWeight = 0;
  totalSttChargeableWeight = 0;
  totalSttGrossWeight = 0;
  totalSttVolumeWeight = 0;
  isDisputeBagging = false;
  bagPhotoProof = [];
  isQuarantine = false;
  isDangerousGoods = false;
  sttClientId = 0;

  constructor(fields?: Partial<CargoDetailStt>) {
    Object.assign(this, fields);
  }
}

export class CargoCommodityList {
  pagination: Pagination;
  data: CargoCommodityData[];
  constructor(pagination: Pagination, data: CargoCommodityData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class CargoCommodityData {
  commodityGroupId: number;
  commodityGroupCode: string;
  commodityGroupName: string;
  createdAt: string;
  updatedAt: string;
  constructor(
    commodityGroupId: number,
    commodityGroupCode: string,
    commodityGroupName: string,
    createdAt: string,
    updatedAt: string
  ) {
    this.commodityGroupId = commodityGroupId;
    this.commodityGroupCode = commodityGroupCode;
    this.commodityGroupName = commodityGroupName;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export class SearchCargoOptions {
  data: SearchCargoOption[];
  constructor(data: SearchCargoOption[]) {
    this.data = data;
  }
}

export class SearchCargoOption {
  transportLabel: string;
  transportType: string;
  constructor(transportLabel: string, transportType: string) {
    this.transportLabel = transportLabel;
    this.transportType = transportType;
  }
}

export class CargoSttList {
  data: CargoSttValidaton[];
  constructor(data: CargoSttValidaton[]) {
    this.data = data;
  }
}

export class CargoSttValidaton {
  isAllowUpdateStatus: boolean;
  errorMessage: string;
  stt: CargoSttDetail;
  constructor(
    isAllowUpdateStatus: boolean,
    errorMessage: string,
    stt: CargoSttDetail
  ) {
    this.isAllowUpdateStatus = isAllowUpdateStatus;
    this.errorMessage = errorMessage;
    this.stt = stt;
  }
}

export class CargoSttDetail {
  bagNo = "";
  sttId = 0;
  sttNo = "";
  sttGrossWeight = 0;
  sttTotalPiece = 0;
  sttVolumeWeight = 0;
  sttProductType = "";
  sttCommodityCode = "";
  sttCommodityName = "";
  sttOriginCityId = 0;
  sttDestinationCityId = 0;
  piece = [] as CargoPieceDetail[];
  constructor(fields?: Partial<CargoSttDetail>) {
    Object.assign(this, fields);
  }
}
export class CargoPieceDetail {
  sttPieceId: number;
  sttPieceGrossWeight: number;
  sttPieceVolumeWeight: number;
  sttPieceNo: number;
  constructor(
    sttPieceId: number,
    sttPieceGrossWeight: number,
    sttPieceVolumeWeight: number,
    sttPieceNo: number
  ) {
    this.sttPieceId = sttPieceId;
    this.sttPieceGrossWeight = sttPieceGrossWeight;
    this.sttPieceVolumeWeight = sttPieceVolumeWeight;
    this.sttPieceNo = sttPieceNo;
  }
}

export class CargoEditResponse {
  cargoId: number;
  cargoNo: string;
  totalSttSuccess: number;
  totalSttFailed: number;
  listSttFailed: string[];
  totalSttAddSuccess: number;
  totalSttRemoveeSuccess: number;
  constructor(
    cargoId: number,
    cargoNo: string,
    totalSttSuccess: number,
    totalSttFailed: number,
    listSttFailed: string[],
    totalSttAddSuccess: number,
    totalSttRemoveeSuccess: number
  ) {
    this.cargoId = cargoId;
    this.cargoNo = cargoNo;
    this.totalSttSuccess = totalSttSuccess;
    this.totalSttFailed = totalSttFailed;
    this.listSttFailed = listSttFailed;
    this.totalSttAddSuccess = totalSttAddSuccess;
    this.totalSttRemoveeSuccess = totalSttRemoveeSuccess;
  }
}

export class CargoProductEntities {
  data: CargoProductData[];
  constructor(data: CargoProductData[]) {
    this.data = data;
  }
}

export class CargoProductData {
  cargoProductTypeId: number;
  cargoProductTypeCode: string;
  cargoProductTypeStatus: string;

  constructor(
    cargoProductTypeId: number,
    cargoProductTypeCode: string,
    cargoProductTypeStatus: string
  ) {
    this.cargoProductTypeId = cargoProductTypeId;
    this.cargoProductTypeCode = cargoProductTypeCode;
    this.cargoProductTypeStatus = cargoProductTypeStatus;
  }
}

export class AirportEntities {
  pagination: Pagination;
  data: AirportData[];
  constructor(pagination: Pagination, data: AirportData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class AirportDetail {
  airportCode: string;
  airportName: string;
  constructor(airportCode: string, airportName: string) {
    this.airportCode = airportCode;
    this.airportName = airportName;
  }
}

export class AirportData {
  airportCode: string;
  airportName: string;
  cityCode: string;
  cityName: string;
  office: string;
  participantId: string;
  name?: string;
  value?: string;
  constructor(
    airportCode: string,
    airportName: string,
    cityCode: string,
    cityName: string,
    office: string,
    participantId: string,
    name?: string,
    value?: string
  ) {
    this.airportCode = airportCode;
    this.airportName = airportName;
    this.cityCode = cityCode;
    this.cityName = cityName;
    this.office = office;
    this.participantId = participantId;
    this.name = name;
    this.value = value;
  }
}

export class AirportRouteTypeData {
  routeType = "";
  maxGrossWeightKg = 0;
  maxVolumeWeightKg = 0;
  maxPieces = 0;
  constructor(fields?: Partial<AirportRouteTypeData>) {
    Object.assign(this, fields);
  }
}

export class AirportDataV2 {
  airportCode = "";
  airportName = "";
  cityCode = "";
  cityName = "";
  name = "";
  value = "";
  office = "";
  participantId = "";
  constructor(fields?: Partial<AirportDataV2>) {
    Object.assign(this, fields);
  }
}

export class CargoAddResponse {
  cargoNo: string;
  totalSttSuccess: number;
  totalSttFailed: number;
  listSttFailed: string[];
  isCargoUsingAwb: boolean;
  bookingRequestId: string;
  constructor(
    cargoNo: string,
    totalSttSuccess: number,
    totalSttFailed: number,
    listSttFailed: string[],
    isCargoUsingAwb: boolean,
    bookingRequestId: string
  ) {
    this.cargoNo = cargoNo;
    this.totalSttSuccess = totalSttSuccess;
    this.totalSttFailed = totalSttFailed;
    this.listSttFailed = listSttFailed;
    this.isCargoUsingAwb = isCargoUsingAwb;
    this.bookingRequestId = bookingRequestId;
  }
}

export class ListLastReadCargo {
  cargoNumber = "";
  awbNumber = "";
  status = "";
  destination = "";
  message = "";
  constructor(fields?: Partial<ListLastReadCargo>) {
    Object.assign(this, fields);
  }
}

export class CargoPlaneAutoData {
  route = "";
  cargoNumber = "";
  vehicleNumber = "";
  estDepartureDate = "";
  estArrivalDate = "";
  flightData: Array<FlightPlanForECargo> = [];
  constructor(fields?: Partial<CargoPlaneAutoData>) {
    Object.assign(this, fields);
  }
}

export class OriginCityData {
  code = "";
  name = "";
  constructor(fields?: Partial<OriginCityData>) {
    Object.assign(this, fields);
  }
}

export class CargoInputData {
  id? = 0;
  totalActualCargoGrossWeight: number | string = 0;
  calcuateActualCargoGrossWeight = 0;
  dimension: DimensionData = new DimensionData();
  totalActualCargoVolumeWeight: number | string = 0;
  totalActualCargoColi = 0;
  estTotalCargoGrossWeight = 0;
  estTotalCargoVolumeWeight = 0;
  originCityData = new OriginCityData();
  cargoComodity = new OptionsClass();
  nog = "";
  cargoNumber = "";
  cargoProduct = "";
  vehicleNumber = "";
  airportOriginCode = "";
  airportDestinationCode = "";
  estDepartureDate = new Date() as any;
  estArrivalDate = new Date(
    new Date().setDate(new Date().getDate() + 6)
  ).toISOString() as any;
  destinationCityData: DestinationCityData = new DestinationCityData();
  flightData: FlightDetail[] = [];
  airportOrigin: AirportData = new AirportData("", "", "", "", "", "", "", "");
  airportDestination: AirportData = new AirportData(
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
  );
  thresholdTime = flags.cargo_config_flight_treshold_default_value.getValue();
  isFromRebookingRTC = false;
  isUseSabre = false;
  isOverCutoffTime = false;
  flightPlaneForECargo: Record<string, string | number>[] = [];
  reasonFailed = "";
  isValidAwb = true;
  isValidOriginOrDestination = true;
  awbTracking: AwbTracking[] = [];
  photoProof: string[] = [];
  isAllowUseProof = false;
  shcCode = "";
  shcName = "";
  constructor(fields?: Partial<CargoInputData>) {
    Object.assign(this, fields);
  }
}

export class SearchFlight {
  dailyFlightNo = "";
  flightNo = "";
  departureDate = "";
  arrivalDate = "";
  totalActualCargoVolumeWeight = 0;
  originAirportCode = "";
  destinationAirportCode = "";
  departureTime = 0;
  arrivalTime = 0;
  transitNumber = 0;
  itineraries: SearchFlight[] = [];
  orderId = 0;
  isNotSupportDg = false;

  constructor(fields?: Partial<SearchFlight>) {
    Object.assign(this, fields);
  }

  get formattedDepartureDate() {
    return formatDateNormal(this.departureDate, "DD MMM YYYY");
  }

  get departureAt() {
    const start = moment(new Date());
    const end = moment(this.departureDate);

    const diffMinutes = end.diff(start, "minutes");

    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    return `${hours} jam ${minutes} menit`;
  }

  get arrivalDays() {
    if (!this.departureDate || !this.arrivalDate) return 0;
    else {
      return moment(this.arrivalDate?.split(" ")[0])
        .utcOffset(this.arrivalDate)
        .diff(
          moment(this.departureDate?.split(" ")[0]).utcOffset(
            this.departureDate
          ),
          "days"
        );
    }
  }

  get formattedTransitNumber() {
    if (this.itineraries.length <= 1) {
      return "langsung";
    }

    return `${this.itineraries.length - 1} transit`;
  }
}

export class DimensionPerKoliDetail {
  sttOrBag = "";
  totalPieces = 1;
  sttPieceLength = 10;
  sttPieceWidth = 20;
  sttPieceHeight = 30;
  sttPieceGrossWeight = 1;
  sttPieceVolumeWeight = 0;

  constructor(fields?: Partial<DimensionPerKoliDetail>) {
    Object.assign(this, fields);
  }
}

export class DimensionPerKoliData {
  totalPieces = 0;
  actualGrossWeight = 0;
  actualVolumeWeight = 0;
  dimensionPieces: DimensionPerKoliDetail[] = [];

  constructor(fields?: Partial<DimensionPerKoliData>) {
    Object.assign(this, fields);
  }
}

export class FlightAvailable {
  isAvailable = false;

  constructor(fields?: Partial<FlightAvailable>) {
    Object.assign(this, fields);
  }
}

export class CargoScanFailed {
  sttNumber = "";
  demNo = "";
  lastStatus = "";
  failureReason = "";
  success = false; // for rescan and success
  storageKey = "";

  constructor(fields?: Partial<CargoScanFailed>) {
    Object.assign(this, fields);
  }
}

export const CargoStorageKey = {
  FailedListNonRtc: "cargo-non-rtc-scan-failed",
  FailedListEditRtc: "cargo-edit-rtc-scan-failed",
  FailedListRetryBooking: "cargo-retry-booking-scan-failed",
  FailedListEdit: "cargo-edit-detail-scan-failed"
};

export class CalculateVolume {
  height = 0;
  volumeWeight = 0;
  chargeableWeight = 0;
  isUploadProofPhoto = false;
  calculateType = "";
  isMaximumDisputeWeight = false;
  maxAllowedCw = 0;

  constructor(fields?: Partial<CalculateVolume>) {
    Object.assign(this, fields);
  }
}

export class CargoSuccessSummaryData {
  plane = "";
  truck = "";
  ship = "";

  constructor(fields?: Partial<CargoSuccessSummaryData>) {
    Object.assign(this, fields);
  }
}

export class CargoDisputeSummaryData {
  totalCargoDispute = 0;
  totalCargoData = 0;
  totalPercentage = 0;
  totalPlaneDispute = 0;
  totalPlaneData = 0;
  totalPlanePercentage = 0;
  totalTruckDispute = 0;
  totalTruckData = 0;
  totalTruckPercentage = 0;
  totalTrainDispute = 0;
  totalTrainData = 0;
  totalTrainPercentage = 0;
  totalShipDispute = 0;
  totalShipData = 0;
  totalShipPercentage = 0;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<CargoDisputeSummaryData>) {
    Object.assign(this, fields);
  }

  get hasDispute() {
    return this.totalCargoDispute > 0;
  }

  get formatDateRange() {
    if (!this.startDate || !this.endDate) return "";

    const start = moment(this.startDate).format("DD MMM");
    const end = moment(this.endDate).format("DD MMM");

    return `${start} - ${end}`;
  }

  get formatDateRangeFull() {
    if (!this.startDate || !this.endDate) return "";

    const start = moment(this.startDate).format("DD MMMM YYYY");
    const end = moment(this.endDate).format("DD MMMM YYYY");

    return `${start} - ${end}`;
  }

  get downloadFileName() {
    const dateStr = moment().format("YYYY-MM-DD");
    return `cargo-dispute-${dateStr}.xlsx`;
  }

  get hasPlaneDispute() {
    return this.totalPlaneDispute > 0;
  }

  get hasTruckDispute() {
    return this.totalTruckDispute > 0;
  }

  get hasShipDispute() {
    return this.totalShipDispute > 0;
  }

  get hasTrainDispute() {
    return this.totalTrainDispute > 0;
  }
}

export class CargoMinimumWeightSummaryData {
  totalData = 0;
  totalMinimumVolume = 0;
  totalPercentageMinimumVolume = 0;
  startDate = "";
  endDate = "";

  constructor(fields?: Partial<CargoMinimumWeightSummaryData>) {
    Object.assign(this, fields);
  }
}

export class CargoSummaryInProcessData {
  inProcessTotal = 0;

  constructor(fields?: Partial<CargoSummaryInProcessData>) {
    Object.assign(this, fields);
  }
}

export class CargoFailedUnread {
  isShow = false;
  newRcId: number[] = [];

  constructor(fields?: Partial<CargoFailedUnread>) {
    Object.assign(this, fields);
  }
}

export class BagOrStt {
  sttNo = "";
  bagNo = "";
  reasonCode = "";
  message = "";
  messageEn = "";

  constructor(fields?: Partial<BagOrStt>) {
    Object.assign(this, fields);
  }
}

export class CheckEligibleReadyToCargo {
  isEligible = false;
  bagOrStt: BagOrStt[] = [];

  constructor(fields?: Partial<CheckEligibleReadyToCargo>) {
    Object.assign(this, fields);
  }
}
